import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.css';
import { Auth } from 'aws-amplify';

class ForgotPassword extends Component {
  email = undefined;
  state = {
    phase: 0,
    email: '',
  };

  componentDidMount() {
    console.log('forgot password init mount props', this.props);
  }

  onForgotPassword() {
    let self = this;

    const username = this.email.value;
    this.setState({ email: this.email.value });

    // See Cognito forgot password flow https://docs.aws.amazon.com/en_us/cognito/latest/developerguide/using-amazon-cognito-user-identity-pools-javascript-examples.html
    Auth.forgotPassword(username)
      .then((result) => {
        console.log('forgot password result: ', result);
        //window.location.href = '/'
        window.location.href = '/change-password?email=' + username;
      })
      .catch((err) => {
        console.error(err);
        alert(err.message);
      });
  }

  render() {
    return (
      <div className='login-register-wrapper'>
        <div className='login-register'>
          <div className='login-register picture' />
          <div className='login-box login-sidebar'>
            <img
              className='ar-logo'
              src='/img/header-logo.png'
              alt='Audience Rate'
            />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div>
                <div className='login-input-wrapper email-wrapper'>
                  <input
                    disabled={this.props.loading}
                    id='login'
                    placeholder='Email'
                    ref={(node) => (this.email = node)}
                  />
                </div>
                <div className='login-input-wrapper'>
                  <button
                    type='submit'
                    disabled={this.props.loading}
                    id='forgot-password'
                    onClick={() => this.onForgotPassword()}
                  >
                    Send verification code
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({}),
  {}
)(ForgotPassword);
